import styled, { css } from 'styled-components';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { useIndexedDBState, saveFile, useIndexedDBDispatch } from '../../context/indexedDBContext';
import RecentList from '../common/RecentList';
import OpenWithDragNDrop from '../common/OpenWithDragNDrop';
import Button from '../common/Button';
import FileButton from '../common/FileButton';
import iconRecent from '../../img/ico_recent.png';
import iconRecent2X from '../../img/ico_recent@2x.png';
import BannerWelcomeHwp from '../../img/banner_welcome_hwp.png';
import BannerWelcomeHwp2x from '../../img/banner_welcome_hwp@2x.png';
import BannerWelcomeSheet from '../../img/banner_welcome_sheet.png';
import BannerWelcomeSheet2x from '../../img/banner_welcome_sheet@2x.png';
import BannerWelcomeSlide from '../../img/banner_welcome_slide.png';
import BannerWelcomeSlide2x from '../../img/banner_welcome_slide@2x.png';
import NaverWorksIcon from '../../img/ico_works_80.png';
import NaverWorksIcon2x from '../../img/ico_works_80@2x.png';
import NaverWorksTitleImg from '../../img/ico_naverworks_bi.png';
import NaverWorksTitleImg2x from '../../img/ico_naverworks_bi@2x.png';
import iconNewDoc from '../../img/ico_newdoc.png';
import iconNewDoc2x from '../../img/ico_newdoc@2x.png';
import myhomeImg from '../../img/ico_mycom_pc.png';
import myhomeImg2x from '../../img/ico_mycom_pc@2x.png';
import myhomeMacImg from '../../img/ico_mycom_mac.png';
import myhomeMacImg2x from '../../img/ico_mycom_mac@2x.png';

import Dialog from './Dialog';
import { useDispatch } from 'react-redux';
import { closeDialog, openDialog } from '../../store/modules/dialog';
import { setEditMode, setFileName, useDocInfoSliceSelector } from '../../store/modules/docInfo';
import ga from '../../utils/gaConnect';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import {
  DIALOG_TYPE,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  EDIT_FROM,
  MAC_OS_NAME,
  MAX_OPEN_FILE_SIZE,
  PO_EDIT_MODE,
  PRODUCT_TYPE
} from '../../define/global';
import { NAVERWORKS_NAVIGATOR_TYPE } from '../../define/naverworksDefine';
import { Trans, useTranslation } from 'react-i18next';
import {
  genNewFileName,
  getExtension,
  useDoFlowByCheckingResult
} from '../../utils/FileControlUtil';
import FixedAD, { FIXED_AD_ID } from '../common/FixedAD';
import { getFormatImg, isDevicePC, useGetHomeURLWithProductType } from '../../utils/util';
import { showAppInstall } from '../../store/modules/popup';
import { CustomScrollbar } from '../common/CssCommon';
import OpenDocumentDialogMobile from './mobile/OpenDocumentDialogMobile';
import SideButtonArea from '../common/SideButtonArea';
import CONSTANT from '../../define/constant';
import { useRef } from 'react';
import { useWhaleSpaceDataSliceSelector } from '../../store/modules/whaleSpaceData';
import { setMessage } from '../../store/modules/extensionHandle';
import { MESSAGE_TYPE } from '../../define/extension/message';
import {
  setNaverWorksFileInfo,
  useNaverWorksDataSliceSelector
} from '../../store/modules/naverWorksData';
import { getNaverWorksTokenInfo, reauthorizationNaverWorks } from '../../extApis/naverWorksApi';
import { NaverWorksError } from '../../errors';

const DialogBody = styled.div`
  width: ${CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_WIDTH}px;
  height: ${CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_HEIGHT}px;
  background: white;
  border-radius: 2px;
  display: flex;
  flex-flow: column;
  ${({ cssExt }) => cssExt && cssExt}
`;

const PopupContents = styled.div`
  width: 100%;
  height: 351px;
  display: flex;
  padding: 16px;
`;

const PopupFooter = styled.div`
  width: 100%;
  height: 170px;
  display: flex;
  flex-flow: column;
  /* justify-content: center; */
  align-items: center;
`;

// 문서 열기
const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 351px;
  gap: 16px;
`;

const Right = styled.div`
  width: 392px;
  height: 351px;
  margin-right: 16px;
  border: none;
  display: flex;
  flex-direction: column;
  ${({ cssExt }) => cssExt && cssExt}
`;

const POHyperLink = styled.a`
  height: 20px;
  margin-top: 9px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;

const RecentTitleWrapper = styled.div`
  width: 100%;
  height: 32px;
  padding-bottom: 3px;
  border-bottom: 1px solid #b1b6bb;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

const RecentTitle = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 13px;
`;

const RecentImg = styled.img`
  width: 24px;
  height: 24px;
  padding-top: 2px;
  margin-left: 5px;
`;

const RecentBox = styled.div`
  /* height: 70%; */
  //margin: 1rem;
  overflow-y: auto;
  flex: 1;
  ${CustomScrollbar};
`;

const BtnGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const ButtonCommon = css`
  background-color: transparent;
  &:hover {
    background: inherit;
  }
  &:active {
    background: inherit;
  }
`;

const NewDocButton = css`
  ${ButtonCommon}
  width: 100px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
`;

const OpenPCDocButton = css`
  ${ButtonCommon}
  width: 131px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const cssExt = css`
  ${ButtonCommon}
`;

const WelcomeBanner = styled.div`
  width: 100%;
  height: 126px;
  background-image: url(${({ backgroundImg }) => backgroundImg && backgroundImg});
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BannerContentsWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  font-size: 16px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  color: ${({ color }) => color && color};
`;

const WelcomeUser = styled.div`
  font-weight: 400;
`;

const DNDBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const NaverWorksWrapper = styled.div`
  width: 273px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: solid 1px #d8d8d8;
`;

const NaverWorksBIWrapper = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const NaverWorksBI = styled.img`
  width: 80px;
  height: 80px;
`;

const NaverWorksDescriptionText = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  height: 40px;
  font-weight: 700;
  text-align: center;
  color: #2f3133;
  margin-top: 25px;
  margin-bottom: 6px;
`;

const NaverWorksSubText = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 700;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: #bbbfc4;
  margin-bottom: 18px;
`;

const NaverWoksButton = styled.div`
  display: flex;
  width: 239px;
  height: 46px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: solid 1px #b1b6bb;
  font-size: 13px;
  color: #2f3133;
  cursor: pointer;
`;

const NaverWorksTitle = styled.img`
  height: 12px;
  margin-right: 9px;
`;

export const useResponsiveCss = () => {
  const appData = useAppDataSliceSelector();
  return (responsiveCss) => {
    return appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE
      ? css`
          @media screen and (max-width: ${CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_WIDTH +
            CONSTANT.OPEN_DOCUMENT_DIALOG_SIDE_BUTTON_WIDTH * 2}px) {
            ${responsiveCss}
          } ;
        `
      : null;
  };
};

function OpenDocumentDialog({ isShow }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const onClickCloseBtn = () => dispatch(closeDialog());
  const appDataSlice = useAppDataSliceSelector();
  const docInfoSlice = useDocInfoSliceSelector();
  const whaleSpaceDataSlice = useWhaleSpaceDataSliceSelector();
  const whaleUserName =
    whaleSpaceDataSlice.userFullName || i18n.t('OpenDocumentDialog.DefaultUserName');
  const doFlowByCheckingResult = useDoFlowByCheckingResult();
  const responsiveCss = useResponsiveCss();
  const isPCView = isDevicePC(appDataSlice.deviceType);
  const isMacOS = appDataSlice.clientOS === MAC_OS_NAME;

  const poSDKContextState = usePOWebofficeSDKState();
  const poSDKReady = poSDKContextState.poInstance !== null;

  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const getHomeURLWithProductType = useGetHomeURLWithProductType();
  const naverWorksDataSlice = useNaverWorksDataSliceSelector();

  const { formatImg, formatImg2x } = getFormatImg(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType);

  const closeInner = () => {
    onClickCloseBtn();
  };

  const onDialogClose = () => {
    const fileName = genNewFileName();
    dispatch(setFileName(fileName));
    closeInner();
    if (poSDKReady) poSDKContextState.poInstance.handle.activeInput();
  };

  const onNewDocument = () => {
    const fileName = genNewFileName();
    dispatch(setFileName(fileName));
    ga.event({ category: '문서열기', action: '새문서', label: '시작화면' });
    closeInner();
    if (poSDKReady) poSDKContextState.poInstance.handle.activeInput();
  };

  const openDocument = async (
    files,
    callback,
    isNaverWorksFile = false,
    naverWorksFileInfo = null
  ) => {
    if (files && files.length > 0) {
      const file = files[0];
      doFlowByCheckingResult({
        file,
        isNaverWorksFile,
        naverWorksFileInfo,
        openableCallback: (targetFile) => {
          if (poSDKReady) {
            const docinfo = {
              name: targetFile.name,
              blob: targetFile
            };

            const start = new Date();
            poSDKContextState.poInstance.handle
              .openDocument(docinfo)
              .then(() => {
                if (poSDKContextState.poInstance.handle.getViewMode() === PO_EDIT_MODE.READ) {
                  //Open Read Only
                  dispatch(setEditMode(PO_EDIT_MODE.READ));
                }
                saveFile({
                  state: indexedDBState,
                  dispatch: indexedDBDispatch,
                  file: targetFile,
                  isNaverWorksFile,
                  naverWorksFileInfo
                });
                dispatch(setFileName(targetFile.name));
                if (isNaverWorksFile && naverWorksFileInfo) {
                  dispatch(setNaverWorksFileInfo(naverWorksFileInfo));
                }
                if (!isPCView && appDataSlice.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE) {
                  dispatch(showAppInstall());
                }

                const end = new Date();
                if (callback) callback(end - start, docinfo.blob);
                ga.event({
                  category: '문서열기',
                  action: '문서포맷',
                  label: getExtension(targetFile.name).toLowerCase()
                });
              })
              .catch((err) => {
                ga.event({
                  category: '예외 케이스',
                  action: '열람실패_미지원',
                  label: `엔진(${err.errorCode})`
                });
                err.closeDialog.then(() =>
                  window.open(
                    getHomeURLWithProductType(
                      DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase()
                    ),
                    '_self',
                    'noopener,noreferrer'
                  )
                );
              });

            closeInner();
          }
        }
      });
    }
  };

  const onFilePCOpen = (e) => {
    const uploadInfo = e.currentTarget;
    if (uploadInfo.files) {
      openDocument(uploadInfo.files, (executeTime, fileBlob) => {
        ga.event({
          category: '문서열기',
          action: '기기문서',
          label: '시작화면',
          value: executeTime
        });
        ga.event({
          category: '사용지표',
          action: '열람 문서 크기',
          label: '기기문서',
          value: fileBlob.size
        });
      });
    }

    e.currentTarget.value = null;
  };

  const onClickPOHyperLink = () => {
    ga.event({ category: '이동', action: 'PO바로가기', label: '시작화면' });
  };

  const getWelcomeBanner = () => {
    switch (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType) {
      case DOCUMENT_TYPE.SHEET: {
        return {
          banner: BannerWelcomeSheet,
          banner2x: BannerWelcomeSheet2x,
          color: '#5f8f42'
        };
      }
      case DOCUMENT_TYPE.SLIDE: {
        return {
          banner: BannerWelcomeSlide,
          banner2x: BannerWelcomeSlide2x,
          color: '#db7700'
        };
      }
      case DOCUMENT_TYPE.HWP:
      case DOCUMENT_TYPE.WORD:
      default: {
        return {
          banner: BannerWelcomeHwp,
          banner2x: BannerWelcomeHwp2x,
          color: '#437fbb'
        };
      }
    }
  };
  const { banner, banner2x, color } = getWelcomeBanner();
  const userName = useRef(whaleUserName);

  const getOpenPCIcon = (isMacOS) => {
    return isMacOS ? (
      <img
        src={myhomeMacImg}
        alt=""
        srcSet={myhomeMacImg2x}
        width="32px"
        height="32px"
        style={{ marginRight: '8px' }}></img>
    ) : (
      <img
        src={myhomeImg}
        alt=""
        srcSet={myhomeImg2x}
        width="32px"
        height="32px"
        style={{ marginRight: '8px' }}></img>
    );
  };

  const onClickOpenNaverWorks = async () => {
    try {
      const res = await getNaverWorksTokenInfo();
      closeInner();
      dispatch(
        openDialog({
          dialogType: DIALOG_TYPE.DIALOG_NAVERWORKS_BROWSER,
          arg: {
            from: EDIT_FROM.FROM_OPENDIALOG,
            navigatorType: NAVERWORKS_NAVIGATOR_TYPE.DOCUMENT
          }
        })
      );
    } catch (error) {
      if (error instanceof NaverWorksError && error.code === 401) {
        ga.event({
          category: '웍스드라이브',
          action: '연결하기',
          label: whaleSpaceDataSlice.domain
        });
        reauthorizationNaverWorks({ domain: whaleSpaceDataSlice.domain, isSelf: true });
      } else {
        alert(`Naver Works 문서 열기에 실패했습니다.`);
      }
    }
  };

  return (
    <>
      {isPCView === true ? (
        <>
          <Dialog
            icon={formatImg}
            icon2x={formatImg2x}
            title={t(`Common.${DOC_FORMAT_CONFIG_VALUES.name}`)}
            showCloseBtn
            showTitleSeperateLine
            onClickCloseBtn={onDialogClose}
            isShow={isShow}>
            <DialogBody
              cssExt={responsiveCss(
                css`
                  width: ${CONSTANT.OPEN_DOCUMENT_DIALOG_BODY_WIDTH_RESPONSIVE}px;
                `
              )}>
              <PopupContents>
                <Left>
                  {/*appDataSlice.productType === PRODUCT_TYPE.WITH_WHALE_SPACE && (
                    <NaverWorksWrapper>
                      <NaverWorksBIWrapper>
                        <NaverWorksBI src={NaverWorksIcon} srcSet={NaverWorksIcon2x} />
                      </NaverWorksBIWrapper>
                      <NaverWorksDescriptionText>
                        <Trans i18nKey="OpenDocumentDialog.NaverWorksDriveDescription"></Trans>
                      </NaverWorksDescriptionText>
                      <NaverWorksSubText>
                        {t('OpenWithDragNDrop.LimitFileSize', {
                          MAX_OPEN_FILE_SIZE: MAX_OPEN_FILE_SIZE
                        })}
                      </NaverWorksSubText>
                      <NaverWoksButton onClick={onClickOpenNaverWorks}>
                        <NaverWorksTitle src={NaverWorksTitleImg} srcSet={NaverWorksTitleImg2x} />
                        {naverWorksDataSlice.isConnected
                          ? t('Common.DoOpenDoc')
                          : t('Common.DoConnect')}
                      </NaverWoksButton>
                    </NaverWorksWrapper>
                        )*/}
                  <OpenWithDragNDrop openDocument={openDocument}>
                    <BtnGroup>
                      {docInfoSlice.poEditMode === PO_EDIT_MODE.EDIT && (
                        <Button block={!poSDKReady} onClick={onNewDocument} cssExt={NewDocButton}>
                          <img
                            src={iconNewDoc}
                            alt=""
                            srcSet={iconNewDoc2x}
                            width="32px"
                            height="32px"></img>
                          {t('OpenDocumentDialog.NewDocument')}
                        </Button>
                      )}

                      {/* PC 문서 열기 */}
                      {appDataSlice.extensionConnectMode === true ? (
                        <Button
                          onClick={() =>
                            dispatch(
                              setMessage({ action: MESSAGE_TYPE.ACTION_TYPE.GET_LOCAL_FILE })
                            )
                          }
                          cssExt={OpenPCDocButton}>
                          {getOpenPCIcon(isMacOS)}
                          {t('OpenDocumentDialog.OpenPCDocument')}
                        </Button>
                      ) : (
                        <FileButton
                          acceptExt={DOC_FORMAT_CONFIG_VALUES.fullExtList}
                          onChange={onFilePCOpen}
                          cssExt={OpenPCDocButton}>
                          {getOpenPCIcon(isMacOS)}
                          {t('OpenDocumentDialog.OpenPCDocument')}
                        </FileButton>
                      )}
                    </BtnGroup>
                  </OpenWithDragNDrop>
                </Left>
                <Right
                  cssExt={responsiveCss(
                    css`
                      display: none;
                    `
                  )}>
                  <RecentTitleWrapper>
                    <RecentImg src={iconRecent} srcSet={iconRecent2X} />
                    <RecentTitle>{t('OpenDocumentDialog.RecentList')}</RecentTitle>
                  </RecentTitleWrapper>
                  <RecentBox>
                    <RecentList isFrom={EDIT_FROM.FROM_OPENDIALOG} openDocument={openDocument} />
                  </RecentBox>
                </Right>
              </PopupContents>
              <PopupFooter>
                {appDataSlice.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE ? (
                  <>
                    <FixedAD id={FIXED_AD_ID.IN_OPEN_DOCUMENT_DIALOG} />
                    <POHyperLink
                      href="https://www.polarisoffice.com/"
                      target="_blank"
                      onClick={onClickPOHyperLink}>
                      {t('OpenDocumentDialog.LinkPO')}
                    </POHyperLink>
                  </>
                ) : (
                  <WelcomeBanner backgroundImg={banner}>
                    <BannerContentsWrapper color={color}>
                      <WelcomeUser>
                        {i18n.t('OpenDocumentDialog.WelcomeUser', {
                          USER: userName.current
                        })}
                      </WelcomeUser>
                      {i18n.t('OpenDocumentDialog.WelcomeText', {
                        FORMAT: t(`OpenDocumentDialog.${DOC_FORMAT_CONFIG_VALUES.name}`)
                      })}
                    </BannerContentsWrapper>
                  </WelcomeBanner>
                )}
              </PopupFooter>
            </DialogBody>
          </Dialog>
          <SideButtonArea />
        </>
      ) : (
        <OpenDocumentDialogMobile onFilePCOpen={onFilePCOpen} />
      )}
    </>
  );
}

export default OpenDocumentDialog;
